/**
 * A performance timer API that works in browsers, web workers, and Node.js.
 */
export default function perfNow(): number {
  if (typeof performance !== "undefined" && typeof performance.now === "function") {
    return performance.now();
  }

  const [seconds, nanoseconds] = process.hrtime();
  return seconds * 1e3 + nanoseconds / 1e6;
}
